import { jsx as _jsx } from "react/jsx-runtime";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import OutlinedInput from '@mui/material/OutlinedInput';
export const nativeSelectComponentOverrides = {
    MuiNativeSelect: {
        defaultProps: {
            IconComponent: KeyboardArrowDownIcon,
            input: _jsx(OutlinedInput, {})
        }
    }
};
